import { data } from '../../svg/DoNotDisturbOn/data';
import { makeIcon } from '../makeIcon';

export const DoNotDisturbOn = makeIcon(data, 'do_not_disturb_on', 'DoNotDisturbOn');

export default DoNotDisturbOn;
